module.exports = __webpack_public_path__ + "img/edit-02.191c5d8d.svg";